import { npsColors } from "./helpers";

const NpsQuestionRubric = () => (
  <div className="flex items-center gap-2">
    <div className="text-xs">Low</div>
    {npsColors.map((color) => (
      <div
        key={color}
        className="h-3 w-3 rounded-sm"
        style={{ backgroundColor: color }}
      />
    ))}
    <div className="text-xs">High</div>
  </div>
);

export default NpsQuestionRubric;
